<app-breadcrumb [title]="'Listado de Órdenes de Mantenimientos'" [items]="['Mantenimiento']"
  [active_item]="'Ordenes de Mantenimientos'">
</app-breadcrumb>

<div class="container-fluid py-4">

  <!-- FILTROS -->
  <div class="filters-card mb-4">

    <div class="search-row">
      <div class="col-lg-3">
        <div class="search-input flex-grow-1">
          <i class="icofont icofont-search"></i>

          <input type="text" class="form-control" placeholder="Buscar por número de orden o placa..."
            [(ngModel)]="textoBusqueda" (ngModelChange)="resetearPaginacion()">

          <i class="icofont icofont-close clear-icon" *ngIf="textoBusqueda"
            (click)="textoBusqueda=''; resetearPaginacion()">
          </i>
        </div>
      </div>

      <div class="col-lg-3">
        <label class="form-label small">Estado de Órdenes</label>
        <ng-select [items]="estadosOrden" bindLabel="nombre" bindValue="codigo" placeholder="Todos los estados"
          [clearable]="true" [searchable]="false" [(ngModel)]="filtroEstado" (ngModelChange)="alCambiarEstado($event)">
        </ng-select>
      </div>
      <div class="col-lg-3">
        <label class="form-label small">Tipo de Mantenimientos</label>
        <ng-select [items]="TipoMantenimiento" bindLabel="nombre" bindValue="id" placeholder="Todos los tipos"
          [clearable]="true" [searchable]="false" [(ngModel)]="filtroTipo" (ngModelChange)="alCambiarTipo($event)">
        </ng-select>


      </div>

      <div class="col-lg-3">
        <label class="form-label small">Nivel de Prioridad</label>
        <ng-select [items]="prioridades" bindLabel="nombre" bindValue="id" placeholder="Todas las prioridades"
          [clearable]="true" [searchable]="false" [(ngModel)]="filtroPrioridad"
          (ngModelChange)="alCambiarPrioridad($event)">
        </ng-select>

      </div>

    </div>

    <div class="filter-row mt-3">
      <div class="col-lg-3">
        <label class="form-label small">Fecha desde</label>
        <input type="date" class="form-control filter-select" [(ngModel)]="fechaDesde" [max]="fechaActual"
          (ngModelChange)="alCambiarFechaDesde($event)">
      </div>

      <div class="col-lg-3">
        <label class="form-label small">Fecha hasta</label>
        <input type="date" class="form-control filter-select" [(ngModel)]="fechaHasta" [max]="fechaActual"
          (ngModelChange)="alCambiarFechaHasta($event)">
      </div>

      <button type="button" class="btn btn-primary align-self-end" (click)="aplicarFiltros()">
        <i class="icofont icofont-search me-1"></i>
        Buscar
      </button>

      <button type="button" class="btn btn-light align-self-end" (click)="limpiarFiltros()">
        <i class="icofont icofont-close me-1"></i>
        Limpiar
      </button>

      <div class="results-count align-self-end">
        {{ ordenesFiltradas.length }}
        {{ ordenesFiltradas.length === 1 ? 'resultado' : 'resultados' }}
      </div>

    </div>
  </div>

  <!-- RESUMEN DE ESTADOS -->


  <div class="row g-3 maintenance-summary">

    <div class="col-12 col-sm-6 col-xl-3" *ngFor="let estado of resumenEstados">

      <div class="summary-card" [ngClass]="obtenerClaseEstadoCard(estado.codigo)"
        (click)="alCambiarEstado(estado.codigo)">

        <div class="summary-top">
          <div class="summary-icon">
            <i [class]="obtenerIconoEstado(estado.codigo)"></i>
          </div>

          <span class="summary-tag" (click)="alCambiarEstado(estado.codigo)">
            {{ obtenerEtiquetaEstado(estado.codigo) }}
          </span>
        </div>

        <div class="summary-label">
          Órdenes {{ obtenerEtiquetaEstado(estado.codigo).toLowerCase() }}
        </div>

        <div class="summary-value">
          {{ estado.cantidad }}
        </div>

        <div class="summary-footer">
          {{ estado.descripcion || 'Estado de mantenimiento' }}
        </div>

      </div>
    </div>


  </div>



  <!-- TABLA DE ÓRDENES -->
  <div class="card border-0 shadow-sm rounded-4">

    <div class="d-flex justify-content-between align-items-center p-3">
      <div>
        <h5 class="mb-1">Listado de órdenes</h5>
        <small class="text-dark">
          Consulta y gestiona las órdenes de mantenimiento de la flota.
        </small>
      </div>
    </div>


    <div class="table-responsive">
      <table class="table table-plans align-middle mb-0">
        <thead>
          <tr>
            <th>#</th>
            <th>NÚMERO DE ORDEN</th>
            <th>FECHA DE CREACIÓN</th>
            <th>PLACA</th>
            <th>TIPO</th>
            <th>PRIORIDAD</th>
            <th class="text-center">KILOMETRAJE</th>
            <th class="text-center">ESTADO</th>
            <th class="text-center">ACCIONES</th>
          </tr>
        </thead>

        <tbody>
          <!-- Cargando -->
          <tr *ngIf="cargando">
            <td colspan="9" class="text-center py-5">
              <div class="spinner-border spinner-border-sm me-2"></div>
              Cargando órdenes de mantenimiento...
            </td>
          </tr>

          <!-- Órdenes -->
          <ng-container *ngIf="!cargando">
            <tr *ngFor="let orden of ordenesPaginadas; let i = index">

              <!-- Número de fila -->
              <td>
                {{ (paginaActual - 1) * itemsPorPagina + i + 1 }}
              </td>

              <!-- Número de orden -->
              <td>
                <div class="plan-code">
                  {{ orden.numero_orden || '—' }}
                </div>
                <small class="text-dark">ID: {{ orden.id }}</small>
              </td>

              <!-- Fecha de creación -->
              <td>
                {{ orden.fecha_generacion | date:'dd/MM/yyyy' }}
              </td>

              <!-- Placa -->
              <td>
                <div class="vehicle-cell">
                  {{ orden.placa || '—' }}
                </div>
              </td>

              <!-- Tipo de mantenimiento -->
              <td>
                {{ obtenerTipoMantenimiento(orden) }}
              </td>

              <!-- Prioridad -->
              <td>

                <span class="status-pill" [ngClass]="obtenerClasePrioridad(orden)">
                  <span class="dot"></span>
                  {{ obtenerPrioridad(orden) }}
                </span>
              </td>

              <!-- Kilometraje -->
              <td class="text-center">
                {{ orden.kilometraje_generacion != null
                ? (orden.kilometraje_generacion | number:'1.0-0')
                : '—' }}
                <small *ngIf="orden.kilometraje_generacion != null"> km</small>
              </td>

              <!-- Estado -->
              <td class="text-center">
                <span class="status-pill" [ngClass]="obtenerClaseEstado(orden)">
                  <i [class]="obtenerIconoEstado(orden.estado?.codigo)"></i>
                  {{ obtenerEstado(orden).replace('_', ' ') }}
                </span>
              </td>

              <!-- Acciones -->
              <td>
                <div class="acciones-row d-flex justify-content-center gap-1">

                  <button type="button" class="btn btn-sm btn-outline-primary btn-rounded" title="Ver detalle"
                    (click)="verDetalleOrden(orden)">
                    <i class="icofont icofont-eye-alt"></i>
                  </button>

                  <button type="button" *ngIf="orden.estado?.codigo === 'PENDIENTE'" class="btn btn-sm btn-outline-secondary btn-rounded" title="Enviar Órden"
                     (click)="GenerarOrden(orden)">
                    <i class="icofont icofont-space-shuttle"></i>
                  </button>

                  <button type="button" *ngIf="orden.estado?.codigo !== 'FINALIZADA'  && orden.estado?.codigo !== ''" class="btn btn-sm btn-outline-primary btn-rounded" title="Editar Órden"
                    (click)="editarOrden(orden)">
                    <i class="icofont icofont-ui-edit"></i>
                  </button>

                   <button type="button" *ngIf="orden.estado?.codigo !== 'FINALIZADA'" class="btn btn-sm btn-outline-danger btn-rounded" title="Cancelar Órden"
                    (click)="GestionarEstadoOrden(orden, 7)">
                    <i class="icofont icofont-ui-delete"></i>
                  </button>
                    <button type="button" *ngIf="orden.estado?.codigo !== 'FINALIZADA'" class="btn btn-sm btn-outline-warning btn-rounded" title="Pausar Órden"
                    (click)="GestionarEstadoOrden(orden, 5)">
                    <i class="icofont icofont-ui-pause"></i>
                  </button>
                 <button type="button" *ngIf="orden.estado?.codigo !== 'FINALIZADA' && orden.estado?.codigo !== 'ENTREGADA'" class="btn btn-sm btn-outline-success btn-rounded" title="Reanudar Órden"
                    (click)="GestionarEstadoOrden(orden, 1)">
                    <i class="icofont icofont-ui-play"></i>
                  </button>

                </div>
              </td>
            </tr>

            <!-- Sin resultados -->
            <tr *ngIf="ordenesPaginadas.length === 0">
              <td colspan="9" class="text-center py-5">
                <div class="empty-state">
                  <i class="icofont icofont-inbox"></i>
                  <p class="mb-1 fw-semibold">
                    No se encontraron órdenes
                  </p>
                  <p class="text-secondary mb-0 small">
                    Modifica los filtros o verifica que existan órdenes registradas.
                  </p>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>


    <!-- PAGINACIÓN -->
    <div class="table-footer" *ngIf="ordenesFiltradas.length > 0">

      <div class="d-flex align-items-center gap-2">
        <span class="text-secondary small">
          Mostrando {{ rangoMostrado }}
        </span>

        <select class="form-select form-select-sm items-select" [(ngModel)]="itemsPorPagina"
          (ngModelChange)="cambiarItemsPorPagina()">
          <option [ngValue]="5">5 / página</option>
          <option [ngValue]="10">10 / página</option>
          <option [ngValue]="20">20 / página</option>
          <option [ngValue]="50">50 / página</option>
        </select>
      </div>

      <nav aria-label="Paginación de órdenes">
        <ul class="pagination pagination-sm mb-0">

          <li class="page-item" [class.disabled]="paginaActual === 1">
            <button class="page-link" (click)="paginaAnterior()">
              <i class="icofont icofont-rounded-left"></i>
            </button>
          </li>

          <li class="page-item" *ngFor="let p of paginasVisibles" [class.active]="p === paginaActual"
            [class.disabled]="p === '...'">
            <button class="page-link" (click)="irAPagina(p)">
              {{ p }}
            </button>
          </li>

          <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
            <button class="page-link" (click)="paginaSiguiente()">
              <i class="icofont icofont-rounded-right"></i>
            </button>
          </li>

        </ul>
      </nav>
    </div>

  </div>

  <!-- MODAL DETALLE DE LA ORDEN -->
  <div class="modal-detalle-backdrop" *ngIf="mostrarModalDetalleOrden" (click)="cerrarDetalleOrden()">

    <div class="modal-detalle" (click)="$event.stopPropagation()">

      <!-- CABECERA -->
      <div class="modal-detalle-header">

        <div class="modal-title-wrapper">
          <div class="modal-title-icon">
            <i class="icofont icofont-tools"></i>
          </div>

          
<div class="orden-header">
  
  <div class="orden-header-info">
    <div class="orden-titulo">
      <h4>
        {{ ordenSeleccionada?.numero_orden }}
      </h4>

      <span
        class="estado-badge"
        [ngClass]="obtenerClaseEstado(ordenSeleccionada)">
        <i class="icofont icofont-check-circled"></i>
        {{ obtenerEstado(ordenSeleccionada) }}
      </span>
    </div>

    <span class="orden-subtitulo">
      Detalle y seguimiento de la orden de mantenimiento
    </span>
  </div>
</div>

        </div>
 <!-- Botones a la derecha -->
  <div class="d-flex align-items-center flex-wrap gap-2 ms-auto">

    <button
      type="button"
      class="btn btn-outline-primary"
       [disabled]="ordenSeleccionada?.estado?.codigo !== 'PENDIENTE'"
      (click)="GenerarOrden(ordenSeleccionada)">
      <i class="icofont icofont-check me-1"></i>
      Enviar Orden
    </button>

    <button
      type="button"
      class="btn btn-secondary"
      (click)="generarPdfOrden()">
      <i class="icofont icofont-file-pdf me-1"></i>
      Generar PDF
    </button>

  </div>
        <button type="button" class="modal-close" (click)="cerrarDetalleOrden()">
          <i class="icofont icofont-close"></i>
        </button>

      </div>

      <!-- INFORMACIÓN PRINCIPAL -->
      <div class="modal-detalle-body" *ngIf="ordenSeleccionada as orden">


        <ul class="nav nav-tabs mb-3 my-3" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="tab-general" data-bs-toggle="tab" data-bs-target="#contenido-general"
              type="button" role="tab">
              <i class="icofont icofont-info-circle me-1"></i>
              Información general
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button class="nav-link" id="tab-actividades" data-bs-toggle="tab" data-bs-target="#contenido-actividades"
              type="button" role="tab">
              <i class="icofont icofont-tasks me-1"></i>
              Actividades
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button class="nav-link" id="tab-historial" data-bs-toggle="tab" data-bs-target="#contenido-historial"
              type="button" role="tab">
              <i class="icofont icofont-history me-1"></i>
              Historial
            </button>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane fade show active" id="contenido-general" role="tabpanel">
            <!-- Contenido de Información general -->
             
          <div class="information-grid">

            <div class="information-card">
              <span class="information-label">Número de órden</span>
              <strong>{{ orden.numero_orden }}</strong>
            </div>

            <div class="information-card">
              <span class="information-label">Placa</span>
              <strong>{{ orden.placa || orden.vehiculo?.placa || '—' }}</strong>
            </div>

            <div class="information-card">
              <span class="information-label">Fecha de generación</span>
              <strong>{{ orden.fecha_generacion | date:'dd/MM/yyyy HH:mm' }}</strong>
            </div>

            <div class="information-card">
              <span class="information-label">Kilometraje de generación</span>
              <strong>
                {{ orden.kilometraje_generacion | number:'1.0-0' }} KM
              </strong>
            </div>

            <div class="information-card">
              <span class="information-label">Tipo de mantenimiento</span>
              <strong>
                {{ orden.tipoMantenimiento?.nombre
                || orden.tipo_mantenimiento?.nombre
                || '—' }}
              </strong>
            </div>

            <div class="information-card">
              <span class="information-label">Prioridad</span>
              <strong>
                {{ orden.prioridadMantenimiento?.nombre
                || orden.prioridad?.nombre
                || '—' }}
              </strong>
            </div>

            <div class="information-card">
              <span class="information-label">Estado actual</span>
              <strong>{{ obtenerEstado(orden) }}</strong>
            </div>

          </div>

          <div class="aviso-motivo mt-3">
            <i class="icofont icofont-info-circle"></i>
            <div>
              <strong>Motivo: </strong>
              <p>{{ orden.motivo || 'Sin motivo registrado.' }}</p>
            </div>
          </div>
           <div class="aviso-observaciones mt-3 mb-3">
            <i class="icofont icofont-info-circle"></i>
            <div>
              <strong>Observaciones: </strong>
                <p>{{ orden.observaciones || 'Sin observaciones.' }}</p>
            </div>
          </div>


          </div>

          
<div class="tab-pane fade" id="contenido-actividades" role="tabpanel">

  <section class="detalle-section actividades-panel">

    <!-- Encabezado -->
    <div class="actividades-header">
      <div class="section-title">
        <i class="icofont icofont-tasks-alt"></i>
        <span>ACTIVIDADES DE LA ORDEN</span>
      </div>

      <span class="contador-actividades">
        {{ actividadesOrden.length }}
        {{ actividadesOrden.length === 1 ? 'actividad' : 'actividades' }}
      </span>
    </div>

    <!-- Indicadores -->
    <div class="row g-3 mb-4">

      <div class="col-6 col-md-3">
        <div class="actividad-card">
          <span>Total actividades</span>
          <strong>{{ actividadesOrden.length }}</strong>
          <i class="icofont icofont-list"></i>
        </div>
      </div>

      <div class="col-6 col-md-3">
        <div class="actividad-card pendiente">
          <span>Pendientes</span>
          <strong>{{ contarActividades('PENDIENTE') }}</strong>
          <i class="icofont icofont-clock-time"></i>
        </div>
      </div>

      <div class="col-6 col-md-3">
        <div class="actividad-card proceso">
          <span>En proceso</span>
          <strong>{{ contarActividades('EN_PROCESO') }}</strong>
          <i class="icofont icofont-tools"></i>
        </div>
      </div>

      <div class="col-6 col-md-3">
        <div class="actividad-card finalizada">
          <span>Realizadas</span>
          <strong>{{ contarActividades('REALIZADA') }}</strong>
          <i class="icofont icofont-check-circled"></i>
        </div>
      </div>
        <div class="col-6 col-md-3">
        <div class="actividad-card norealizada">
          <span>No Realizadas</span>
          <strong>{{ contarActividades('NO_REALIZADA') }}</strong>
          <i class="icofont icofont-clock-time"></i>
        </div>
      </div>
        <div class="col-6 col-md-3">
        <div class="actividad-card cancelada">
          <span>Canceladas</span>
          <strong>{{ contarActividades('CANCELADA') }}</strong>
          <i class="icofont icofont-close"></i>
        </div>
      </div>

    </div>

    <!-- Progreso -->
   <div class="progreso-actividades mb-4">
  <div class="d-flex justify-content-between mb-2">
    <span>Progreso de ejecución</span>
    <strong>{{ progresoActividades }}%</strong>
  </div>

  <div class="progress">
    <div
      class="progress-bar bg-success"
      role="progressbar"
      [style.width.%]="progresoActividades"
      [attr.aria-valuenow]="progresoActividades"
      aria-valuemin="0"
      aria-valuemax="100">
    </div>
  </div>

  <small class="text-dark">
    {{ contarActividades('REALIZADA') }} de
    {{ actividadesOrden.length }} actividades realizadas
  </small>
</div>

    <!-- Tabla -->
   
<section class="detalle-section actividades-panel">


 
  <!-- Bloqueo por entrega -->
  <div
    *ngIf="!ordenEntregada"
    class="aviso-entrega">

    <i class="icofont icofont-lock"></i>

    <div>
      <strong>Ejecución bloqueada</strong>
      <p>
        Las actividades estarán disponibles para ejecución cuando
        se complete la entrega formal del vehículo.
      </p>
    </div>
  </div>

  <!-- Tabla -->
  <div class="table-responsive tabla-actividades-contenedor">

    <table class="table tabla-actividades align-middle">

      <thead>
        <tr>
          <th class="col-numero">#</th>
          <th>Actividad</th>
          <th>Sistema / parte</th>
          <th>Estado</th>
          <th>Fecha de Registro</th>
          
          <th class="text-center col-acciones">Acciones</th>
        </tr>
      </thead>

      <tbody>

        <tr
          *ngFor="let actividad of actividadesOrden; let i = index">

          <td class="col-numero">{{ i + 1 }}</td>

          <td>
            <div class="actividad-nombre">
              {{ actividad.servicioRealizado?.tipo_de_mantenimiento
                  || 'Sin nombre' }}
            </div>
            <small class="actividad-referencia">
              Actividad #{{ actividad.id }}
            </small>
          </td>

          <td>
            <div class="sistema-nombre">
              {{ actividad.servicioRealizado?.sistema || '—' }}
            </div>
            <small class="parte-nombre">
              {{ actividad.servicioRealizado?.parte || '—' }}
            </small>
          </td>

          <td>
            <span
              class="estado-actividad"
              [ngClass]="obtenerClaseEstadoActividad(actividad)">
              {{ obtenerNombreEstadoActividad(actividad) }}
            </span>
          </td>

          <td class="fecha-actividad">
            {{
              actividad.fecha_inicio
                ? (actividad.fecha_inicio | date:'dd/MM/yy HH:mm')
                : '—'
            }}
          </td>

         

          <td class="col-acciones">
            <div class="acciones-actividad">

           <!--    <button
                type="button"
                class="btn btn-detalle"
                title="Consultar detalle"
                (click)="verDetalleActividad(actividad)">
                <i class="icofont icofont-eye"></i>
              </button> -->

              <button
                *ngIf="obtenerCodigoEstadoActividad(actividad) === 'PENDIENTE'"
                type="button"
                class="btn btn-iniciar"
                [disabled]="!ordenEntregada"
                [title]="ordenEntregada
                  ? 'Registrar actividad'
                  : 'Primero debe entregarse la orden'"
                (click)="gestionarOrden(actividad)">

                <i class="icofont icofont-play-alt-2"></i>
                Gestionar
              </button>

              <button
                *ngIf="obtenerCodigoEstadoActividad(actividad) === 'EN_PROCESO'"
                type="button"
                class="btn btn-finalizar"
                (click)="finalizarActividad(actividad)">

                <i class="icofont icofont-check"></i>
                Finalizar
              </button>

            </div>
          </td>

        </tr>

        <tr *ngIf="actividadesOrden.length === 0">
          <td colspan="7" class="sin-actividades">
            <i class="icofont icofont-clipboard"></i>
            <strong>No hay actividades registradas</strong>
            <span>Esta orden no tiene actividades para mostrar.</span>
          </td>
        </tr>

      </tbody>
    </table>
  </div>

</section>


  </section>
</div>


          <div class="tab-pane fade" id="contenido-historial" role="tabpanel">
            <!-- Contenido de Historial -->
            <!-- HISTORIAL -->
            <section class="detalle-section">

              <div class="section-title">
                <i class="icofont icofont-history"></i>
                <span>HISTORIAL DE LA ORDEN</span>
              </div>
              <div class="table-responsive">
                <table class="table table-plans align-middle">
                  <thead>
                    <tr>
                      <th>FECHA</th>
                      <th>EVENTO</th>
                      <th>DESCRIPCIÓN</th>
                      <th>ESTADO ANTERIOR</th>
                      <th>ESTADO NUEVO</th>
                      <th>USUARIO</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngIf="cargandoHistorial">
                      <td colspan="6" class="text-center py-4">
                        Cargando historial...
                      </td>
                    </tr>

                    <tr *ngFor="let evento of ordenSeleccionada?.historial">
                      <td>{{ evento.fecha_evento | date:'dd/MM/yyyy HH:mm' }}</td>
                      <td>{{ evento.tipo_evento || '—' }}</td>
                      <td>{{ evento.descripcion || '—' }}</td>
                      <td>{{ evento.estadoAnterior?.codigo || 'SIN ESTADO' }}</td>
                      <td>{{ evento.estadoNuevo?.codigo || '—' }}</td>
                      <td>{{ evento.usuario?.nombre || evento.usuario.email || '—' }}</td>
                    </tr>

                    <tr *ngIf="!ordenSeleccionada?.historial?.length">
                      <td colspan="6" class="text-center py-4">
                        No hay eventos históricos disponibles.
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>

            </section>

          </div>
        </div>




      </div>

      <!-- ACCIONES DEL MODAL -->
      <div class="modal-detalle-footer">

        <button type="button" class="btn btn-light" (click)="cerrarDetalleOrden()">
          Cerrar
        </button>

        <button *ngIf="ordenSeleccionada && puedeIniciar(ordenSeleccionada)" type="button" class="btn btn-primary"
          (click)="iniciarOrden(ordenSeleccionada)">
          <i class="icofont icofont-play-alt-2 me-1"></i>
          Iniciar mantenimiento
        </button>

      </div>

    </div>
  </div>

  <!-- MODAL  PARA GESTIONAR LA ACTIVIDAD-->
   
<!-- Modal gestionar actividad -->

<app-gestionar-actividad
  *ngIf="mostrarModalActividad"
  [orden]="ordenSeleccionada"
  [actividad]="actividadSeleccionada"
  [modoConsulta]="modoConsultaActividad"
  (cerrar)="cerrarModalActividad()"
  (guardar)="registrarResultadoActividad($event)"
   (actividadActualizada)="cargarActividadesOrden($event)"
  >
</app-gestionar-actividad>

</div>